import { Component, EventEmitter, Output } from '@angular/core';

import { UploadWizardService } from '../../../../services/upload-wizard-service/upload-wizard.service';

/**
 * Component that is used to get the new layer name and description data and also the associated project, if required
 */
@Component({
    selector: 'cw-select-new-layer',
    templateUrl: 'select-new-layer.component.html',
    styleUrls: ['select-new-layer.component.scss'],
    standalone: false,
})
export class SelectNewLayerComponent {
    today = new Date();
    /**
     * Event emitted when the user clicks on the close icon
     */
    @Output() closeClick: EventEmitter<void> = new EventEmitter<void>();

    constructor(public uploadWizardService: UploadWizardService) {}

    onClose(): void {
        this.closeClick.emit();
    }
}
